import { metricsTrack } from '../../utilities/analytics/index.js';
import { triggerExternalLinkPopup } from '../../utilities/behavior-helpers/index.js';
import { observeDOM } from '../../utilities/dom-helpers/index.js';
import { getFormAttributes } from '../../../common/metrics.js';

/* eslint-disable sonarjs/cognitive-complexity */
let btnSubmit = null;
let isFormSubmitted = false;
const setActiveLabel = (label) => label === null || label === void 0 ? void 0 : label.classList.add('active');
const removeActiveLabel = (label) => label === null || label === void 0 ? void 0 : label.classList.remove('active');
const enableSubmitButton = (btn) => {
    btn.removeAttribute('disabled');
    btn.classList.remove('locked');
};
const disableSubmitButton = (btn) => {
    btn.setAttribute('disabled', 'true');
    btn.classList.add('locked');
};
const inputEvents = (inputDivs) => {
    inputDivs.forEach((inputDiv) => {
        const label = inputDiv.querySelector('label');
        const input = inputDiv.querySelector('.FormTextbox__Input');
        if (!input)
            return;
        input.addEventListener('focus', () => {
            setActiveLabel(label);
        });
        input.addEventListener('focusout', () => {
            if (input.value.length === 0) {
                removeActiveLabel(label);
            }
        });
        if (input.title) {
            const helpElement = document.createElement('span');
            helpElement.classList.add('helptext');
            helpElement.textContent = input.title;
            inputDiv.insertBefore(helpElement, label);
            label.classList.add('with-helptext');
        }
    });
};
const selectEvents = (selectDivs) => {
    selectDivs.forEach((selectDiv) => {
        const select = selectDiv.querySelector('select');
        const selectValue = window.sessionStorage.getItem(select.id);
        if (!select)
            return;
        select.addEventListener('focus', () => {
            select.classList.add('active');
        });
        select.addEventListener('focusout', () => {
            select.classList.remove('active');
        });
        select.addEventListener('change', () => {
            window.sessionStorage.setItem(select.id, select.value);
        });
        if (selectValue)
            select.value = selectValue;
    });
};
const epiFormInit = (form) => {
    btnSubmit = form.querySelector('button[name=submit]:not([value=NextStep])');
    form.addEventListener('keydown', (e) => {
        if (e.code === 'Enter' &&
            e.target.tagName !== 'BUTTON' &&
            e.target.getAttribute('type') !== 'reset') {
            e.stopPropagation();
        }
    }, true);
    if (btnSubmit) {
        btnSubmit.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            disableSubmitButton(btnSubmit);
            metricsTrack('cevt_form_submit', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'submit', dlv_button_text: e.target.textContent }));
        });
    }
};
const applyCheckboxStylings = (input) => {
    if (input.type !== 'radio' && input.type !== 'checkbox')
        return;
    const parentLabel = input.parentElement;
    const initialized = parentLabel.classList.contains('initialized');
    if (initialized)
        return;
    parentLabel.classList.add('initialized');
    if (input.type === 'radio')
        parentLabel.classList.add('radio');
    if (input.type === 'checkbox')
        parentLabel.classList.add('checkbox');
    if (input.checked)
        parentLabel.classList.add('checked');
    parentLabel.addEventListener('click', () => {
        if (input.type === 'radio')
            parentLabel
                .parentNode.querySelectorAll('.checked')
                .forEach(label => label.classList.remove('checked'));
        if (input.checked)
            parentLabel.classList.add('checked');
        else
            parentLabel.classList.remove('checked');
    });
};
const applyBtnSkipEvent = (form) => {
    const skipBtn = form.querySelector('.btnSkip');
    if (!skipBtn)
        return;
    const link = skipBtn.dataset.href;
    skipBtn.addEventListener('click', () => {
        window.location.href = link;
    });
};
const applyExternalLinksEvents = (form) => {
    // form in modal only
    if (!form.closest('cvt-modal'))
        return;
    const anchors = [
        ...Array.from(form.querySelectorAll('a')),
    ];
    const modal = document.querySelector('cvt-modal[popupid="external-link"]');
    if (!modal)
        return;
    const externalLinkPopup = modal.querySelector('external-link');
    const ctx = {};
    ctx.externalLinkPopup = externalLinkPopup;
    anchors.forEach(anchor => {
        ['click', 'keydown'].forEach(event => {
            anchor.addEventListener(event, (e) => {
                if (e.key && e.key !== 'Enter')
                    return;
                triggerExternalLinkPopup(e, ctx);
            });
        });
    });
};
const formInit = (form) => {
    epiFormInit(form);
    const inputDivs = [
        ...Array.from(form.querySelectorAll('.FormTextbox')),
    ];
    const selectDivs = [
        ...Array.from(form.querySelectorAll('.FormSelection')),
    ];
    const inputs = [
        ...Array.from(form.querySelectorAll('input, textarea')),
    ];
    let isFormStarted = false;
    inputEvents(inputDivs);
    selectEvents(selectDivs);
    applyExternalLinksEvents(form);
    applyBtnSkipEvent(form);
    inputs.forEach(input => {
        applyCheckboxStylings(input);
        input.addEventListener('focus', () => {
            if (!isFormStarted) {
                isFormStarted = true;
                metricsTrack('cevt_form_start', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'start' }));
            }
        });
    });
    // if form is not in modal
    if (!form.closest('cvt-modal')) {
        metricsTrack('cevt_form_view', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'view' }));
    }
};
/** Reset form input label positions. Prevents label overlapping with input text. */
const resetFormLabels = (form) => {
    if (!form)
        return;
    const inputDivs = [
        ...Array.from(form.querySelectorAll('.FormTextbox')),
    ];
    inputDivs.forEach((inputDiv) => {
        const label = inputDiv.querySelector('label');
        const input = inputDiv.querySelector('.FormTextbox__Input');
        if (label && (input === null || input === void 0 ? void 0 : input.value)) {
            setActiveLabel(label);
        }
    });
};
const handleMutations = (addedNodes, form) => {
    applyExternalLinksEvents(form);
    addedNodes.forEach(node => {
        if (!node.parentElement)
            return;
        // on step change
        if (node.parentElement.classList.contains('Form__NavigationBar__ProgressBar__CurrentStep') &&
            !isFormSubmitted) {
            const firstFormControl = form.querySelector(".FormStep:not(.hide) input:not([type='hidden']), .FormStep:not(.hide)  textarea, .FormStep:not(.hide)  select");
            firstFormControl === null || firstFormControl === void 0 ? void 0 : firstFormControl.focus();
            const stepTitle = document.querySelector('.FormStep:not(.hide) .FormStep__Description');
            const stepNumber = document.querySelector('.FormStep:not(.hide) .FormStep__Title');
            metricsTrack('cevt_form_step_interaction', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_step_number: stepNumber === null || stepNumber === void 0 ? void 0 : stepNumber.textContent, dlv_step_name: stepTitle === null || stepTitle === void 0 ? void 0 : stepTitle.textContent }));
        }
        // on validation error message
        if (node.parentElement.classList.contains('Form__Element__ValidationError')) {
            // submit button should be always enabled due to validation policy
            enableSubmitButton(btnSubmit);
        }
    });
};
const setEpiserverFormEvents = (form) => {
    const episerverFormSelector = '.EPiServerForms';
    if (typeof window.$$epiforms !== 'undefined') {
        window.$$epiforms(document).ready(() => {
            window.$$epiforms(episerverFormSelector).on('formsStepValidating', () => {
                var _a, _b, _c;
                const dataProcessingElementIdVar = `${(_a = window.formConsentsElements) === null || _a === void 0 ? void 0 : _a.dataProcessingElementId}_0`;
                const retailReferralElementIdVar = `${(_b = window.formConsentsElements) === null || _b === void 0 ? void 0 : _b.retailReferralElementId}_0`;
                const marketingElementIdVar = `${(_c = window.formConsentsElements) === null || _c === void 0 ? void 0 : _c.marketingElementId}_0`;
                const consentDataProcessing = document.getElementById(dataProcessingElementIdVar);
                const consentRetailReferral = document.getElementById(retailReferralElementIdVar);
                const consentMarketing = document.getElementById(marketingElementIdVar);
                // Set in storage for event success, as it has no access to form elments
                if (consentDataProcessing !== null) {
                    sessionStorage.setItem('consentDataProcessing', (consentDataProcessing === null || consentDataProcessing === void 0 ? void 0 : consentDataProcessing.checked) ? 'yes' : 'no');
                }
                else {
                    sessionStorage.removeItem('consentDataProcessing');
                }
                if (consentRetailReferral !== null) {
                    sessionStorage.setItem('consentRetailReferral', (consentRetailReferral === null || consentRetailReferral === void 0 ? void 0 : consentRetailReferral.checked) ? 'yes' : 'no');
                }
                else {
                    sessionStorage.removeItem('consentRetailReferral');
                }
                if (consentMarketing !== null) {
                    sessionStorage.setItem('consentMarketing', (consentMarketing === null || consentMarketing === void 0 ? void 0 : consentMarketing.checked) ? 'yes' : 'no');
                }
                else {
                    sessionStorage.removeItem('consentMarketing');
                }
                const visibleErrMsgSelector = '.ValidationFail > .Form__Element__ValidationError';
                const validationMessages = Array.from(document.querySelectorAll(visibleErrMsgSelector)).map(el => el.innerText);
                if (validationMessages.length) {
                    metricsTrack('cevt_form_error', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'error', dlv_form_error_message: validationMessages
                            .join('_')
                            .substring(0, 99) }));
                }
            });
            window
                .$$epiforms(episerverFormSelector)
                .on('formsSubmitted', (event) => {
                if (event.isFinalizedSubmission && event.isSuccess) {
                    metricsTrack('cevt_form_success', Object.assign(Object.assign({}, getFormAttributes(form, 'cevt_form_success')), { dlv_event_action: 'success' }));
                    isFormSubmitted = true;
                    setTimeout(() => {
                        var _a, _b;
                        (_a = document.querySelector('#successMessage')) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                        (_b = document
                            .querySelector('.Form__Success__Message')) === null || _b === void 0 ? void 0 : _b.scrollIntoView();
                    }, 100);
                }
            });
            window.$$epiforms(episerverFormSelector).on('formsSubmittedError', () => {
                metricsTrack('cevt_form_error', Object.assign(Object.assign({}, getFormAttributes(form)), { dlv_event_action: 'error', dlv_form_error_message: 'error 500' }));
            });
        });
    }
};
document.addEventListener('DOMContentLoaded', () => {
    const forms = Array.from(document.querySelectorAll('form.EPiServerForms'));
    forms.forEach(form => {
        formInit(form);
        // watch for success and validation errors messages
        observeDOM(form, (mutation) => {
            const addedNodes = [];
            mutation.forEach((record) => {
                if (record.addedNodes.length)
                    addedNodes.push(...record.addedNodes);
            });
            handleMutations(addedNodes, form);
        });
    });
});
window.addEventListener('load', () => {
    const form = document.querySelector('form.EPiServerForms');
    // Delay in ms used when resetting the form labels to make sure that browser has prefilled the input values
    const DELAY_CHECK = 100;
    if (form)
        setTimeout(() => resetFormLabels(form), DELAY_CHECK);
    setEpiserverFormEvents(form);
});

export { applyBtnSkipEvent, applyExternalLinksEvents, disableSubmitButton, enableSubmitButton, formInit, handleMutations, inputEvents, removeActiveLabel, resetFormLabels, selectEvents, setActiveLabel, setEpiserverFormEvents };
